import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, Icon, Table, Button, message } from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import SendTangoGiftCard from "../RewardProgram/send-tango-gift-card-modal";
import { Translate } from "react-translated";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import CustomHeader from '../../CommonHeader/CustomHeader';

class TangoGiftCards extends Component {
  state = {
    loading: true,
    giftcards: [],
    page: 1,
    total_pages: 0,
    user: this.props.auth.user,
    send_tango_gift_card: false,
  };
  componentDidMount = () => {
    this.loadgiftcards(1);
  };
  loadgiftcards = (page) => {
    const api = "/api/tango_gift_cards?page=" + page;

    this.setState({ loading: true });

    axios.get(api).then((res) => {
      const giftcards = res.data.objects;
      this.setState({
        loading: false,
        page: res.data.page,
        total_pages: res.data.total_pages,
        giftcards,
      });
    });
  };
  render() {
    const { loading, giftcards, page, total_pages, user } = this.state;

    // Define AgGrid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Date"} />,
        field: 'date',
        minWidth: 120,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Date'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'date',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.date}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Name"} />,
        field: 'name',
        minWidth: 150,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Email"} />,
        field: 'email',
        minWidth: 200,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Email'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'email',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.email}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Amount"} />,
        field: 'amount',
        minWidth: 120,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Amount'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'amount',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.amount}</div>
        ),
      },
    ];

    // Prepare row data for AgGrid
    const rowDatas = giftcards.map((giftcard, i) => ({
      key: i,
      date: moment(giftcard.created_on).format("MM/DD/YYYY"),
      name: giftcard.name,
      email: giftcard.email,
      amount: F.dollar_format(giftcard.amount),
    }));

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="gift" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Tango Gift Cards`} />
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <Button
              onClick={() => this.setState({ send_tango_gift_card: true })}
            >
              <Icon type="mail" /> <Translate text={`Send Tango Gift Card`} />
            </Button>
          }
        >
          <CustomAgGridTable
            rowDatas={rowDatas}
            columnDefss={columnDefs}
          />
          <Pagination
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadgiftcards(page);
            }}
          />
        </Card>
        <SendTangoGiftCard
          showModal={this.state.send_tango_gift_card}
          hideModal={() => this.setState({ send_tango_gift_card: false })}
          user={user}
          refresh={() => this.loadgiftcards(1)}
        />
      </div>
    );
  }
}

export default TangoGiftCards;



// WEBPACK FOOTER //
// ./src/scenes/SendAGift/index.js